import { createFileRoute } from "@tanstack/react-router";
import { TradeGuidePage, seoHead } from "@/components/hubs/HubPages";
import { TRADE_GUIDES } from "@/lib/regionalHubs";

const DATA = TRADE_GUIDES.find((x) => x.slug === "/learn/social-media-views-colorado-business")!;

export const Route = createFileRoute("/learn/social-media-views-colorado-business")({
  head: () => seoHead("/learn/social-media-views-colorado-business", "How Colorado Businesses Reach 10,000+ Social Media Views", "Short video, local hooks, and consistent posting that have helped Colorado businesses grow from a few hundred views to 10,000\u2013100,000+ a month.", "article"),
  component: () => <TradeGuidePage guide={DATA} />,
});
